<template>
  <div>
    <v-container fluid grid-list-md text-xs-center>
      <v-row align="center" justify="center">
        <v-col cols="12" md="3" v-for="(card) in totalizadoresOrdenados" :key="card.titulo">
          <v-card :style="{'background-color': `${card.cor}`}">
            <v-card-title class="justify-center title white--text pt-0">{{ card.titulo }}</v-card-title>
            <v-card-text>
              <v-row class="headline white--text">
                <v-col cols="12" class="text-center pa-0">{{ getMoney(card.valorMonetario) }}</v-col>
                <v-col cols="12" class="text-center pa-0">{{  getPercent(percentualExibido === 'quantidade' ? card.valorPercentualQtd : card.valorPercentual) }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import {
  getMoney,
  getPercent,
} from '../../common/functions/helpers';
import { listarPagamentosTotalizadores } from '../../common/resources/liquidacao/pagamento';

export default {
  name: 'LiquidacaoCardsTotalizadores',
  components: {
  },
  props: {
    filtros: Object,
    percentual: String,
  },
  data() {
    return {
      lista: [],
      percentualExibido: 'monetario',
      filtrosAplicados: this.filtros,
    };
  },
  watch: {
    filtros: {
      handler() {
        this.filtrosAplicados = this.filtros;
        this.buscaTotalizadores();
      },
    },
  },
  computed: {
    totalizadoresOrdenados() {
      function compare(a, b) {
        if (a.ordenacao < b.ordenacao) {
          return -1;
        }
        if (a.ordenacao > b.ordenacao) {
          return 1;
        }
        return 0;
      }

      return this.lista.sort(compare);
    },
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    usuarioFornecedor() {
      return this.usuarioLogado.tipo === 'FORNECEDOR';
    },
  },
  methods: {
    getMoney,
    getPercent,
    buscaTotalizadores() {
      if (this.percentual) {
        this.percentualExibido = this.percentual;
      }
      const params = {
        ...this.filtrosAplicados,
        visao: 'visao_contrato',
      };

      listarPagamentosTotalizadores(params, this.$resource)
        .then((response) => {
          const dadosRetornados = response.data;
          this.tratarCards(dadosRetornados);
          this.tratarCores();
        })
        .catch((err) => {
          if (err.data) {
            this.$toast(err.data.error);
          }
        });
    },

    tratarCores() {
      this.lista.forEach((item) => {
        if (item.status === 'PAGAMENTO') {
          item.cor = 'rgb(26, 188, 156)';
          item.ordenacao = 1;
        } else if (item.status === 'PENDENTE_APURACAO') {
          item.cor = 'rgb(230, 126, 34)';
          item.ordenacao = 2;
        } else if (item.status === 'REJEITADA') {
          item.cor = 'rgb(231, 76, 60)';
          item.ordenacao = 3;
        }
      });
    },

    tratarCards(dadosRetornados) {
      const cards = [];

      cards.push({
        status: 'PAGAMENTO',
        titulo: this.$tc('label.pagamento', 1),
      });

      cards.push({
        status: 'PENDENTE_APURACAO',
        titulo: this.$tc('label.pendente_apuracao', 1),
      });

      cards.push({
        status: 'REJEITADA',
        titulo: this.$tc('label.apuracao_rejeitada', 1),
      });

      this.lista = cards.map((card) => {
        const valores = dadosRetornados
          .filter((dados) => dados.status === card.status)[0] || {};

        return {
          ...card,
          valorMonetario: valores.valorMonetario || 0,
          valorPercentual: valores.valorPercentual || 0,
          valorPercentualQtd: valores.valorPercentualQtd || 0,
        };
      });
    },
  },
};
</script>
